import React from 'react';
import {Button} from 'primereact/button';


class Facts extends React.Component {
  constructor(){
    super()
    this.state = {
      quotes: JSON.parse(localStorage.getItem("facts")) || []
    }
  }

  removeQuote = (index) => {
    // make a function that returns a boolean
    const updatedQuotes = this.state.quotes.filter((quote,i) => index !== i )
    // remove the fav quote from local storage
    localStorage.setItem("facts", JSON.stringify(updatedQuotes))
    // remove the fav quote from virtual DOM
    this.setState({quotes: updatedQuotes})
  }
  
  mappedFacts = () => this.state.quotes.map((quote,index)=><div >

    <p className='fav-facts' key={index}>
      {quote}
      {/* <button onClick={()=>this.removeQuote(index)}>Delete</button> */}
    </p>
    <Button onClick={()=>this.removeQuote(index)} icon='pi pi-trash' className='p-button-primary btn-del-quote'/>
  </div>
  )

  render(){
    return (
      <div>
      {/* <div className='fact-content'> */}
        {this.state.quotes.length>0 ? this.mappedFacts() : <h1>No Favorites Saved Yet.</h1>}
      </div>
    )
  }
  }

export default Facts